import { Card } from "react-bootstrap";

/** Compact KPI tile used across the dashboard and requisition views. */
export default function StatCard({
  label,
  value,
  icon,
  hint,
  tone = "primary",
}: {
  label: string;
  value: React.ReactNode;
  icon: string;
  hint?: string;
  tone?: "primary" | "success" | "warning" | "danger" | "info" | "secondary";
}) {
  return (
    <Card className="h-100 shadow-sm">
      <Card.Body className="d-flex align-items-center gap-3">
        <span
          className={`d-inline-flex align-items-center justify-content-center rounded-3 bg-${tone}-subtle text-${tone}`}
          style={{ width: 46, height: 46, fontSize: "1.35rem" }}
        >
          <i className={`bi ${icon}`}></i>
        </span>
        <div>
          <div className="fs-4 fw-bold lh-1">{value}</div>
          <div className="text-muted small">{label}</div>
          {hint && <div className="text-muted" style={{ fontSize: ".72rem" }}>{hint}</div>}
        </div>
      </Card.Body>
    </Card>
  );
}
